import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "non-form-errors"
}
const _hoisted_2 = {
  key: 0,
  class: "help"
}
const _hoisted_3 = { class: "table-container" }
const _hoisted_4 = { class: "table is-hoverable is-fullwidth" }
const _hoisted_5 = { class: "has-background-grey-darker" }
const _hoisted_6 = {
  key: 0,
  scope: "col"
}
const _hoisted_7 = {
  key: 1,
  scope: "col"
}
const _hoisted_8 = {
  class: "field",
  style: {"display":"flex","align-items":"center","gap":"10px","margin-top":"15px"}
}
const _hoisted_9 = { class: "button is-static" }
const _hoisted_10 = {
  key: 1,
  class: "table-container mt-5"
}
const _hoisted_11 = { class: "table is-hoverable is-fullwidth" }
const _hoisted_12 = {
  key: 0,
  class: "tag is-info"
}
const _hoisted_13 = {
  key: 1,
  class: "tag is-light"
}
const _hoisted_14 = { class: "has-background-grey-darker" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_YieldRow = _resolveComponent("YieldRow")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.apiErrors)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          ('non_field_errors' in _ctx.apiErrors)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apiErrors['non_form_errors'], (error, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: `non-form-error-${index}`
                    }, _toDisplayString(error), 1))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("table", _hoisted_4, [
        _createElementVNode("thead", _hoisted_5, [
          _createElementVNode("tr", null, [
            _cache[5] || (_cache[5] = _createElementVNode("th", { scope: "col" }, "Adjust", -1)),
            _cache[6] || (_cache[6] = _createElementVNode("th", { scope: "col" }, "Product", -1)),
            _cache[7] || (_cache[7] = _createElementVNode("th", { scope: "col" }, "Price", -1)),
            _cache[8] || (_cache[8] = _createElementVNode("th", { scope: "col" }, "Ratio", -1)),
            (_ctx.results.yields.length)
              ? (_openBlock(), _createElementBlock("th", _hoisted_6, "Leg"))
              : _createCommentVNode("", true),
            (_ctx.results.yields.length)
              ? (_openBlock(), _createElementBlock("th", _hoisted_7, "Weighted"))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formset, (values, index) => {
            return (_openBlock(), _createBlock(_component_YieldRow, {
              key: `yield-row-${index}`,
              rowId: index,
              products: _ctx.products,
              values: values,
              apiErrors: _ctx.apiErrors,
              result: _ctx.results.yields[index],
              onRowUpdate: _ctx.rowUpdate
            }, null, 8, ["rowId", "products", "values", "apiErrors", "result", "onRowUpdate"]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.calculateYield(false))),
        type: "button",
        class: "button is-outlined is-info"
      }, [...(_cache[9] || (_cache[9] = [
        _createElementVNode("span", { class: "icon" }, [
          _createElementVNode("i", {
            "aria-hidden": "true",
            class: "fas fa-calculator"
          })
        ], -1),
        _createElementVNode("span", null, " Calculate ", -1)
      ]))]),
      _createElementVNode("span", _hoisted_9, "Current Total: " + _toDisplayString(_ctx.results.total ? _ctx.results.total.toFixed(3) : '0'), 1),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.copyCurrentTotal && _ctx.copyCurrentTotal(...args))),
        type: "button",
        class: "button is-outlined is-light",
        title: "Copy to clipboard"
      }, [...(_cache[10] || (_cache[10] = [
        _createElementVNode("span", { class: "icon" }, [
          _createElementVNode("i", {
            "aria-hidden": "true",
            class: "fas fa-copy"
          })
        ], -1)
      ]))]),
      _cache[13] || (_cache[13] = _createElementVNode("span", { class: "button is-static" }, "→", -1)),
      _cache[14] || (_cache[14] = _createElementVNode("span", { class: "button is-static" }, "Target:", -1)),
      _withDirectives(_createElementVNode("input", {
        class: "input",
        type: "number",
        step: "any",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.targetTotal) = $event)),
        placeholder: "Enter target total",
        style: {"width":"150px"}
      }, null, 512), [
        [
          _vModelText,
          _ctx.targetTotal,
          void 0,
          { number: true }
        ]
      ]),
      _createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.applyDeltaAdjustment && _ctx.applyDeltaAdjustment(...args))),
        type: "button",
        class: "button is-outlined is-warning"
      }, [...(_cache[11] || (_cache[11] = [
        _createElementVNode("span", { class: "icon" }, [
          _createElementVNode("i", {
            "aria-hidden": "true",
            class: "fas fa-adjust"
          })
        ], -1),
        _createElementVNode("span", null, " Adjust ", -1)
      ]))]),
      _createElementVNode("button", {
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.initRows && _ctx.initRows(...args))),
        type: "button",
        class: "button is-outlined is-danger"
      }, [...(_cache[12] || (_cache[12] = [
        _createElementVNode("span", { class: "icon" }, [
          _createElementVNode("i", {
            "aria-hidden": "true",
            class: "fas fa-trash-alt"
          })
        ], -1),
        _createElementVNode("span", null, " Clear ", -1)
      ]))])
    ]),
    (_ctx.originalResults.yields.length > 0 && _ctx.hasAnyAdjustments)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _cache[17] || (_cache[17] = _createElementVNode("h3", { class: "subtitle has-text-white mb-3" }, "Calculation Results - Before & After Adjustments", -1)),
          _createElementVNode("table", _hoisted_11, [
            _cache[16] || (_cache[16] = _createElementVNode("thead", { class: "has-background-grey-darker" }, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", { scope: "col" }, "Leg #"),
                _createElementVNode("th", { scope: "col" }, "Product"),
                _createElementVNode("th", { scope: "col" }, "Input Price"),
                _createElementVNode("th", { scope: "col" }, "Delta Applied (price)"),
                _createElementVNode("th", { scope: "col" }, "Adjusted Price"),
                _createElementVNode("th", { scope: "col" }, "Original Weighted"),
                _createElementVNode("th", { scope: "col" }, "Adjusted Weighted")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.adjustedResults.yields, (adjustedResult, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: `result-${index}`,
                  class: _normalizeClass({'has-background-primary': _ctx.formset[index]?.ratio > 0, 'has-background-danger': _ctx.formset[index]?.ratio <= 0})
                }, [
                  _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.getProductName(_ctx.formset[index]?.product)), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.formset[index]?.price || '-'), 1),
                  _createElementVNode("td", null, [
                    (adjustedResult.delta_applied && adjustedResult.adjusted_price)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString((adjustedResult.adjusted_price - parseFloat(_ctx.formset[index]?.price || 0)).toFixed(6)), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_13, "None"))
                  ]),
                  _createElementVNode("td", null, _toDisplayString(adjustedResult.adjusted_price ? adjustedResult.adjusted_price.toFixed(6) : _ctx.formset[index]?.price || '-'), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.originalResults.yields[index] ? _ctx.originalResults.yields[index].weighted.toFixed(6) : '-'), 1),
                  _createElementVNode("td", null, _toDisplayString(adjustedResult.weighted.toFixed(6)), 1)
                ], 2))
              }), 128))
            ]),
            _createElementVNode("tfoot", _hoisted_14, [
              _createElementVNode("tr", null, [
                _cache[15] || (_cache[15] = _createElementVNode("th", {
                  colspan: "5",
                  class: "has-text-right"
                }, "Total Weighted Yield:", -1)),
                _createElementVNode("th", null, _toDisplayString(_ctx.originalResults.total ? _ctx.originalResults.total.toFixed(6) : '-'), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.adjustedResults.total.toFixed(6)), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}